import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import Select from "react-select";
import { selectprocessedData } from "../../../features/importSlice";
import { signInUser } from "../../Utility/Auth";

// const BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:5001/api";

const SelectGroupImport = ({ gp, groups, code, processedData }) => {
  const auth = signInUser();
  const { aamarId } = auth;
  const [selectedOption, setSelectedOption] = useState(null);
  const [groupOptions, setGroupOptions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [matched, setMatched] = useState(true);

  const dispatch = useDispatch();

  useEffect(() => {
    // const fetchgroups = async () => {
    try {
      // const result = await axios.get(`${BASE_URL}/group/list/${aamarId}`);
      const options =
        groups?.map((element) => ({
          label: element.name,
          value: element._id,
        })) || [];

      setGroupOptions(options);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching groups:", error);
      setLoading(false);
    }
    // };

    // fetchgroups();
  }, [groups]);

  // console.log("selectedOption", selectedOption);

  useEffect(() => {
    if (gp && !selectedOption) {
      // Only update when `selectedOption` is null
      const cleanGp = String(gp).trim().toLowerCase();
      const result = groups?.find(
        (item) =>
          item?.name?.trim().toLowerCase() === cleanGp ||
          item?._id === gp
      );

      if (!result) {
        setMatched(false);
        setSelectedOption({
          label: "Select group",
          value: "",
        });
      } else {
        setMatched(true);
        setSelectedOption({
          label: result.name,
          value: result._id,
        });
      }
    }
  }, [gp, groups]); // Add `groups` dependency to prevent stale values

  // Update Selected Value
  const setGroupHandler = ({ id, name }) => {
    const selected = processedData?.find((pro) => pro.code === code);
    const rest = processedData?.filter((pro) => pro.code !== code);
    // console.log("select and rest", id);

    let products = [
      ...rest,
      {
        ...selected,
        group: id,
        groupName: name,
      },
    ];

    // dispatch(selectName({ name, id }));
    dispatch(selectprocessedData(products));
  };

  const handleSelectChange = (selected) => {
    // console.log("Selected Group:", selected);

    setSelectedOption(selected); // Update state immediately before dispatching
    setGroupHandler({ id: selected.value, name: selected.label });
  };

  const customStyles = {
    singleValue: (provided, state) => ({
      ...provided,
      color: state.selectProps.matched ? "red" : "black", // Apply color based on 'matched'
    }),
    // Change the border color of the select box
    control: (provided, state) => ({
      ...provided,
      borderColor: state.selectProps.matched ? "red" : "gray", // Conditional border color
      boxShadow: state.isFocused ? "0 0 0 1px red" : "none",
      // "&:hover": {
      //   borderColor: state.selectProps.matched ? "red" : "gray",
      // },
    }),

    // Change the placeholder text color
    placeholder: (provided, state) => ({
      ...provided,
      color: state.selectProps.matched ? "red" : "gray", // Conditional placeholder color
    }),
  };

  return (
    <div>
      <Select
        styles={{
          ...customStyles,
          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
        }}
        matched={!matched}
        value={selectedOption}
        options={groupOptions}
        placeholder={loading ? "Loading groups..." : "Select group"}
        onChange={handleSelectChange}
        isSearchable
        classNamePrefix="react-select"
        menuPortalTarget={document.body}
      />
    </div>
  );
};

export default SelectGroupImport;
